import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@instructure/ui-buttons';
import { IconEditLine } from '@instructure/ui-icons';
import makeScrollable from '../../../../../common/components/shared/functionality/makeScrollable';
import t from '@instructure/quiz-i18n/es/format-message';
import { omitProps } from '@instructure/ui-react-utils';
var EditButton = /*#__PURE__*/function (_Component) {
  function EditButton() {
    var _this;
    _classCallCheck(this, EditButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EditButton, [].concat(args));
    _defineProperty(_this, "focus", function () {
      _this.button.focus();
    });
    _defineProperty(_this, "handleButtonRef", function (node) {
      return _this.button = node;
    });
    return _this;
  }
  _inherits(EditButton, _Component);
  return _createClass(EditButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(IconButton, Object.assign({
        ref: this.handleButtonRef,
        size: "small",
        withBackground: false,
        withBorder: false,
        renderIcon: IconEditLine,
        onClick: this.props.onClick
      }, omitProps(this.props, this.constructor.propTypes), {
        screenReaderLabel: this.props.screenreaderText
      }));
    }
  }]);
}(Component);
_defineProperty(EditButton, "propTypes", {
  onClick: PropTypes.func.isRequired,
  screenreaderText: PropTypes.string
});
_defineProperty(EditButton, "defaultProps", {
  screenreaderText: t('Edit')
});
export default makeScrollable(EditButton);